function createMaintenanceElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createMaintenanceButton(action, label, tone, disabled = false) {
  const button = createMaintenanceElement('button', `btn ${tone} btn-sm`, label);
  button.type = 'button';
  button.dataset.ccMaintAction = action;
  button.disabled = disabled;
  return button;
}

function createMaintenanceTable(headers, rows, emptyMessage) {
  const table = createMaintenanceElement('table', 'cc-table');
  const head = document.createElement('thead');
  const headRow = document.createElement('tr');
  headRow.append(...headers.map((header) => createMaintenanceElement('th', '', header)));
  head.append(headRow);
  const body = document.createElement('tbody');
  if (rows.length) {
    body.append(...rows);
  } else {
    const row = document.createElement('tr');
    const cell = createMaintenanceElement('td', 'muted', emptyMessage);
    cell.colSpan = headers.length;
    row.append(cell);
    body.append(row);
  }
  table.append(head, body);
  const scroll = createMaintenanceElement('div', 'cc-table-scroll');
  scroll.append(table);
  return scroll;
}

function createMaintenanceOperationRow(row, { actionLabel, formatCcTime, statusLabel }) {
  const operation = document.createElement('td');
  operation.append(
    createMaintenanceElement('strong', '', actionLabel(row.action)),
    createMaintenanceElement('div', 'mono', row.action || ''),
  );
  const outcome = createMaintenanceElement('td');
  outcome.append(createMaintenanceElement('span', `cc-tag ${row.outcome === 'success' ? 'ok' : 'warn'}`, statusLabel(row.outcome)));
  const tr = document.createElement('tr');
  tr.append(
    createMaintenanceElement('td', '', formatCcTime(row.created_at)),
    createMaintenanceElement('td', '', row.actor_name || String(row.actor_user_id || '')),
    operation,
    outcome,
    createMaintenanceElement('td', 'mono', row.trace_id || ''),
  );
  return tr;
}

function createCard(label) {
  const card = createMaintenanceElement('div', 'cc-card');
  card.append(createMaintenanceElement('div', 'label', label));
  return card;
}

export function renderCommandCenterMaintenance(root, data, helpers) {
  if (!root) return;
  const agent = data.updateAgent || {};
  const migration = data.migration || {};
  const latest = migration.latest;

  const banner = createMaintenanceElement('div', 'cc-banner muted', '高风险维护操作需要二次确认，并自动记录操作人和执行结果。');
  const agentCard = createCard('镜像更新代理');
  const agentState = createMaintenanceElement('div', 'value cc-value-compact');
  agentState.append(
    createMaintenanceElement('i', `cc-dot ${agent.configured ? 'ok' : 'warn'}`),
    document.createTextNode(` ${agent.configured ? '已配置' : '未配置'}`),
  );
  const agentActions = createMaintenanceElement('div', 'cc-actions');
  agentActions.append(
    createMaintenanceButton('registry-check', '检查镜像', 'btn-secondary', !agent.configured),
    createMaintenanceButton('registry-deploy', '执行更新', 'btn-primary', !agent.configured),
  );
  agentCard.append(
    agentState,
    createMaintenanceElement('div', 'foot mono', `${agent.baseUrl || '—'} · 超时 ${agent.timeoutMs || '—'}ms`),
    agentActions,
  );

  const migrationCard = createCard('数据库迁移');
  if (migration.available === false) {
    migrationCard.append(createMaintenanceElement('span', 'cc-na', helpers.unavailableLabel(migration.reason)));
  } else {
    const latestName = latest?.name || '—';
    const foot = createMaintenanceElement('div', 'foot');
    foot.append(
      document.createTextNode('最新：'),
      createMaintenanceElement('span', 'mono', latestName),
      document.createTextNode(` · ${helpers.formatCcTime(latest?.applied_at)}`),
    );
    migrationCard.append(
      createMaintenanceElement('div', 'value cc-value-compact', `已应用 ${migration.appliedCount ?? 0} 项`),
      foot,
    );
  }
  const statusCards = createMaintenanceElement('div', 'cc-grid-2');
  statusCards.append(agentCard, migrationCard);

  const taskCard = createCard('任务维护');
  const taskActions = createMaintenanceElement('div', 'cc-actions');
  taskActions.append(
    createMaintenanceButton('reconcile-dry', '预检释放', 'btn-secondary'),
    createMaintenanceButton('reconcile-run', '确认释放', 'btn-primary'),
  );
  const result = createMaintenanceElement('div', 'cc-code cc-maint-result');
  result.id = 'cc-maint-result';
  result.hidden = true;
  taskCard.append(
    createMaintenanceElement('p', 'muted', '先预检，再由管理员确认释放僵死批量任务。两种动作均写入管理审计。'),
    taskActions,
    result,
  );
  const retentionCard = createCard('指标保留');
  retentionCard.append(
    createMaintenanceElement('div', 'value cc-value-compact', '自动保留策略'),
    createMaintenanceElement('div', 'foot', data.retention?.note || '未接入'),
  );
  const maintenanceCards = createMaintenanceElement('div', 'cc-grid-2');
  maintenanceCards.append(taskCard, retentionCard);

  const operations = createCard('近期维护操作（30 天）');
  operations.append(createMaintenanceTable(
    ['时间', '操作人', '动作', '结果', '追踪编号'],
    (data.recentOperations || []).map((row) => createMaintenanceOperationRow(row, helpers)),
    '暂无维护操作',
  ));
  root.replaceChildren(banner, statusCards, maintenanceCards, operations);
}
